<template>
  <div class="container">
    <h3 class="mt-4"> Hjelpevideo</h3>


    <div class="flex-container mt-5 mb-5">
      <div class="flex-item">
        <div class="video-wrapper">
          <iframe src="https://www.youtube.com/embed/gxNfcEaVRto?mute=1" allowfullscreen></iframe>
        </div>
        <div><strong>Hvordan avinstallere TastyOrder app </strong></div>
      </div>
      <div class="flex-item">
          <div class="video-wrapper">
            <iframe src="https://www.youtube.com/embed/as_OeqZStIw?mute=1" allowfullscreen></iframe>
          </div>
          <div><strong>Hvordan installere/oppdatere TastyOrder app </strong></div>
      </div>
      <div class="flex-item">
          <div class="video-wrapper">
            <iframe src="https://www.youtube.com/embed/kPICcKl_xIg?mute=1" allowfullscreen></iframe>
          </div>
          <div><strong>Hvordan sette på lyd på TastyOrder app </strong></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  text-align: center;
}

.flex-item {
  flex: 1 1 200px;
  max-width: 300px;
}

.video-wrapper {
  position: relative;
  padding-bottom: 177.78%; /* 9:16 aspect ratio for vertical videos */
  height: 0;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 800px) {
  .flex-item {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
<script setup lang="ts">
</script>